module.exports = __webpack_public_path__ + "static/media/en.92e9e3bd.svg";